import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import CheckCircle from "../../../../../components/SVGComponents/CheckCircle";
import TimeQuery from "../../../../../components/SVGComponents/TimeQuery";
import { FileUploader } from "react-drag-drop-files";
import { PrimaryButton } from "@fluentui/react";
import themeContext from "../../../../../context/theme/ThemeContext";
import userContext from "../../../../../context/users/UserContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../../constants/Constants";
import "./peerreview.css";

const PeerReviewTimelineBody = (props) => {
  const [t] = useTranslation();
  const { getThemeColor, getAlterColor } = useContext(themeContext);
  const { peerReviewAdmin, peerReviewEvaluator } = useContext(userContext);
  const { showToastv2 } = useContext(toastContext);
  const [data, setData] = useState(null);
  const [events, setEvents] = useState([]);

  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (data) {
      let generatedEvents = generatePeerReviewEvents(data);
      setEvents(generatedEvents);
    }
  }, [data]);
  const formatName = (name, username) => {
    if (!name && !username) return "";
    if (!name) return username;
    return username ? `${name} (${username})` : name;
  };
  function generatePeerReviewEvents(data = {}) {
    return [
      {
        time: formatTimestamp(data.originalSubmissionDate),
        userDetails: {
          name: formatName(data.radiologistName, data.radiologistUsername),
          namelabel: t("peer-review.radiologist"),
        },
      },
      {
        time: formatTimestamp(data.peerReviewAssignmentTimeStamp),
        userDetails: {
          name: formatName(data.peerReviewerName, data.peerReviewerUserName),
          namelabel: t("peer-review.reviewer"),
          assignedBy: formatName(
            data.reviewAssignedBy,
            data.reviewAssignedByUserName
          ),
          assignedBylabel: t("peer-review.assigned-by"),
        },
      },
      {
        time: formatTimestamp(data.reviewSubmissionTimeStamp),
        userDetails: null,
      },
      {
        time: formatTimestamp(data.evaluatorAssignmentTimeStamp),
        userDetails: {
          name: formatName(data.evaluatorName, data.evaluatorUsername),
          namelabel: t("peer-review.evaluator"),
          assignedBy: formatName(
            data.evauluatorAssignedBy,
            data.evaluatorAssignedByUserName
          ),
          assignedBylabel: t("peer-review.assigned-by"),
        },
      },
      {
        time: formatTimestamp(data.evaluatorSubmissionTimeStamp),
        userDetails: null,
      },
    ];
  }
  function formatTimestamp(inputTime) {
    if (!inputTime || typeof inputTime !== "string") {
      return "";
    }

    const dateObj = new Date(inputTime.replace(" ", "T"));

    if (isNaN(dateObj.getTime())) {
      return "";
    }

    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear().toString().slice(-2);
    const time = dateObj.toLocaleTimeString("en-GB", { hour12: false });

    return `${day}-${month}-${year} ${time}`;
  }
  const previewFile = (previewFile) => {
    if (!previewFile) {
      console.error("No file data provided!");
      return;
    }

    try {
      let base64 = previewFile.includes(",")
        ? previewFile.split(",")[1]
        : previewFile;
      const fileData = _base64ToArrayBuffer(base64);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url, "_blank", "width=600,height=700,location=no");
    } catch (error) {
      console.error("Error decoding Base64:", error);
    }
  };

  function _base64ToArrayBuffer(base64) {
    try {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    } catch (error) {
      console.error("Invalid Base64 string:", error);
      return null;
    }
  }

  return (
    <div className="peer-review-main-container">
      <div className="peer-review-first-row">
        <div className="peer-review-col-80">
          {props.timelineStatus.map((data, idx) => (
            <div className="peer-review-sub-row" key={idx}>
              <div className="peer-review-col-left">{data.name}</div>
              <div className="peer-review-col-middle">
                <span
                  className="peer-review-circle"
                  style={{
                    backgroundColor: getAlterColor("#191919", "#FFFFFF"),
                  }}
                ></span>
                <div className="peer-review-checkcircle">
                  {events[idx]?.time !== "" ? <CheckCircle /> : <TimeQuery />}
                </div>
                {idx != 4 && <div className="peer-review-timeline"></div>}
              </div>
              <div className="peer-review-col-right">
                {events[idx] && (
                  <div>
                    <span>{events[idx]?.time}</span>
                    {events[idx]?.time !== "" ? (
                      events[idx]?.userDetails && (
                        <div className="peer-review-user-details">
                          <span>
                            <span>{events[idx]?.userDetails?.namelabel}: </span>
                            {events[idx]?.userDetails?.name}
                          </span>
                          <div>
                            {events[idx]?.userDetails?.assignedBylabel && (
                              <>
                                <span>
                                  {events[idx]?.userDetails?.assignedBylabel}:{" "}
                                </span>
                                <span>
                                  {events[idx]?.userDetails?.assignedBy || " "}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      )
                    ) : (
                      <span></span>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {data?.reviewStatus == 3 && peerReviewEvaluator && (
        <div className="peer-review-second-row">
          <label
            style={{ color: getThemeColor("primary-color") }}
            className="peer-label"
            htmlFor="uploadNote"
          >
            {t("peer-review.upload-evaluation-sheet")}
          </label>
          <div className="peerreview-uploader-div">
            <div className="peer-review-fileuploader-main">
              <FileUploader
                maxSize={1}
                handleChange={(file) => {
                  props.saveEvaluationSheet(file);
                  props.uploadFileName(file ? file.name : "");
                  if(data?.evaluationSheetPath|| props.evaluationSheetPath.current )
                  props.setEvaluationSheetOverride(true);
                  props.isFileSaved(true);
                }}
                style={{ width: "40%" }}
                name="file"
                className="filesUploader-label"
                types={["pdf"]}
                multiple={false}
                onTypeError={() => {
                  setAlertSuccessModal(() => {
                    const newItem = { ...alertSuccessModal };
                    newItem.show = true;
                    newItem.heading = "Alert";
                    newItem.isError = false;
                    newItem.isSuccess = false;
                    newItem.isWarning = true;
                    newItem.description = t(
                      "peer-review.not-supported-files"
                    );
                    return newItem;
                  });
                }}
                onSizeError={() => {
                  setAlertSuccessModal(() => {
                    const newItem = { ...alertSuccessModal };
                    newItem.show = true;
                    newItem.heading = t("peer-review.file-too-large-title");
                    newItem.description = t("peer-review.file-too-large-message");
                    return newItem;
                  });
                }}
                label={t("peer-review.evaluation-sheet")}
              >
                <p
                  className="peer-reivew-file-uploader"
                  style={{ color: getThemeColor("primary-color") }}
                >
                  {t("peer-review.drag-or-browse-files")}
                </p>
              </FileUploader>
            </div>
            <PrimaryButton
              text={t("button.save")}
              style={{
                fontSize: "13px",
                fontWeight: "600",
                lineHeight: "20px",
                marginTop: "12px",
                marginBottom: "12px",
                marginRight: "1%",
              }}
              onClick={props.handleUpload}
            />
          </div>
          <>
            {props.fileName && (
              <>
                <label
                  style={{ color: getThemeColor("primary-color") }}
                  className="peer-label"
                  htmlFor="uploadNote"
                >
                  {t("peer-review.evaluation-sheet")}
                </label>

                {(data?.evaluationSheetPath || props.uploadFileName) && (
                  <div
                    className="previous-file-upload"
                    onClick={() => {
                      if (data?.evaluationSheetPath && !props.evaluationSheetOverride) {
                        props.getSavedEvaluationSheet();
                      } else if (
                        props.uploadFileName &&
                        props.evaluationSheetPath && !props.evaluationSheetOverride
                      ) {
                        props.getSavedEvaluationSheet();
                      } else {
                        showToastv2(
                          TOAST_TYPE.ERROR,
                          t("peer-review.save-files")
                        );
                      }
                    }}
                  >
                    <div>
                      <strong>{props.extractFileName(props.fileName)}</strong>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        </div>
      )}
      <>
        {data?.reviewStatus == 4 &&
          (peerReviewEvaluator || peerReviewAdmin) && (
            <div className="peer-review-second-row">
              <label
                style={{ color: getThemeColor("primary-color") }}
                className="peer-label"
                htmlFor="uploadNote"
              >
                {t("peer-review.evaluation-sheet")}
              </label>

              {data?.evaluationSheetPath && (
                <div
                  className="previous-file-upload"
                  onClick={() => {
                    if (data?.evaluationSheetPath) {
                      props.downloadSavedEvalualtionSheet(
                        data.assignmentId,
                        data.evaluationSheetPath
                      );
                    }
                  }}
                >
                  <div>
                    <strong>{props.extractFileName(props.fileName)}</strong>
                  </div>
                </div>
              )}
            </div>
          )}
      </>
    </div>
  );
};

export default PeerReviewTimelineBody;
